import { render, staticRenderFns } from "./404page.vue?vue&type=template&id=2532db59&scoped=true&"
import script from "./404page.vue?vue&type=script&lang=js&"
export * from "./404page.vue?vue&type=script&lang=js&"
import style0 from "./404page.vue?vue&type=style&index=0&id=2532db59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532db59",
  null
  
)

export default component.exports